/* City In Bloom landing page */
(() => {
  const root = document.querySelector('.lp-cib');
  if (!root) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* hero: the slideshow sits inside giant letters. Scrolling swells and thickens them
     until they flood the banner, then the title fades in over the photograph */
  const hero = document.getElementById('hero');
  const svg = document.getElementById('heroSvg');
  const slides = $$('image', svg), cur = document.getElementById('cur'), counter = document.getElementById('counter');
  const hmText = document.getElementById('hmText'), hmFill = document.getElementById('hmFill'), hmBg = document.getElementById('hmBg');
  const lines = $$('.hm-l', hmText), mask = document.getElementById('heroMask');
  const title = document.getElementById('heroTitle'), eb = title.querySelector('.eyebrow'), h1 = title.querySelector('h1');
  const shade = document.getElementById('heroShade'), foot = document.getElementById('heroFoot');
  const clampH = (x, a = 0, b = 1) => Math.min(b, Math.max(a, x));
  const eio = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  let idx = 0;
  const pad = n => String(n + 1).padStart(2, '0');
  function go(next){
    slides[idx].classList.remove('on'); idx = next;
    const s = slides[idx]; s.classList.remove('on'); void s.getBoundingClientRect(); s.classList.add('on');
    cur.textContent = pad(idx);
    counter.classList.remove('run'); void counter.offsetWidth; counter.classList.add('run');
  }
  slides[0].classList.add('on'); counter.classList.add('run');
  if (!reduce) setInterval(() => { if (!document.hidden) go((idx + 1) % slides.length); }, 5500);

  let HW, HH, fs, cx, cy, ink;
  const WORDS = { wide: [['City ', 'in'], ['Bloom']], tall: [['City'], ['in'], ['Bloom']] };
  function layoutHero(){
    HW = svg.clientWidth; HH = svg.clientHeight;
    svg.setAttribute('viewBox', `0 0 ${HW} ${HH}`);
    [hmBg, hmFill].forEach(r => { r.setAttribute('width', HW); r.setAttribute('height', HH); });
    mask.setAttribute('x', 0); mask.setAttribute('y', 0); mask.setAttribute('width', HW); mask.setAttribute('height', HH);
    slides.forEach(i => { i.setAttribute('width', HW); i.setAttribute('height', HH); });
    const wide = HW / HH > 1.05, words = wide ? WORDS.wide : WORDS.tall, pitch = .8;
    lines.forEach((t, i) => {
      const w = words[i]; t.textContent = '';
      if (!w) { t.style.display = 'none'; return; }
      t.style.display = '';
      if (w.length === 2) { t.append(w[0]); const it = document.createElementNS('http://www.w3.org/2000/svg', 'tspan'); it.setAttribute('font-style', 'italic'); it.textContent = w[1]; t.append(it); }
      else t.append(w[0]);
    });
    // measure each line at 100px to fit the width
    lines.forEach(t => t.setAttribute('font-size', 100));
    const shown = lines.filter(t => t.style.display !== 'none');
    const em = Math.max(...shown.map(t => t.getComputedTextLength())) / 100;
    const reserve = foot.offsetHeight + HH * .07 + 12, topPad = HH * .04;
    const availH = HH - reserve - topPad;
    const span = .84 + pitch * (shown.length - 1);
    fs = Math.min(HW * .94 / em, availH / span);
    cx = HW / 2; cy = topPad + availH / 2;
    const b1 = cy - span * fs / 2 + .84 * fs;
    shown.forEach((t, i) => { t.setAttribute('font-size', fs); t.setAttribute('x', cx); t.setAttribute('y', b1 + i * pitch * fs); });
    ink = fs;
    drawHero();
  }
  function drawHero(){
    const total = hero.offsetHeight - innerHeight;
    const p = reduce ? 1 : clampH(-hero.getBoundingClientRect().top / total);
    const scale = 1 + .6 * eio(clampH(p / .78)), sw = eio(clampH((p - .28) / .46)) * ink * 1.2;
    hmText.setAttribute('transform', `translate(${cx} ${cy}) scale(${scale}) translate(${-cx} ${-cy})`);
    hmText.setAttribute('stroke-width', sw.toFixed(1));
    hmFill.setAttribute('opacity', eio(clampH((p - .66) / .14)).toFixed(3));
    shade.style.opacity = eio(clampH((p - .72) / .2)).toFixed(3);
    const te = clampH((p - .76) / .14), th = clampH((p - .83) / .15);
    eb.style.opacity = eio(te); eb.style.transform = `translateY(${(1 - eio(te)) * 14}px)`;
    h1.style.opacity = eio(th); h1.style.transform = `translateY(${(1 - eio(th)) * 30}px)`;
    foot.style.opacity = 1 - clampH(p / .1); foot.style.visibility = p > .1 ? 'hidden' : 'visible';
  }
  (document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve()).then(layoutHero);
  layoutHero();
  addEventListener('resize', layoutHero);
  if (!reduce) { let ht = false; addEventListener('scroll', () => { if (!ht) { ht = true; requestAnimationFrame(() => { ht = false; drawHero(); }); } }, { passive: true }); }

  /* page tint follows the suite in view */
  const themed = $$('[data-theme]', root);
  const io = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) root.dataset.theme = e.target.dataset.theme;
  }), { rootMargin: '-45% 0px -45% 0px' });
  themed.forEach(t => io.observe(t));

  /* reveals */
  const rev = new IntersectionObserver(es => es.forEach(e => {
    if (e.isIntersecting) { e.target.classList.add('in'); rev.unobserve(e.target); }
  }), { threshold: .18, rootMargin: '0px 0px -6% 0px' });
  $$('.rv,.lines,[data-reveal]').forEach(el => rev.observe(el));


  /* read more toggles */
  $$('.toggle').forEach(b => b.addEventListener('click', () => {
    const open = b.getAttribute('aria-expanded') !== 'true';
    b.setAttribute('aria-expanded', open);
    document.getElementById(b.getAttribute('aria-controls')).classList.toggle('open', open);
  }));

  /* wax seals: a pinned stage. Each seal is pressed in the centre, then blooms
     (in the shape of the seal itself) to reveal the full flat lay */
  const press = document.getElementById('press');
  if (press) {
    const stick = press.querySelector('.press-stick');
    const cue = press.querySelector('.cue');
    const seals = $$('.seal', press), pips = $$('.pip', press);
    if (reduce) { press.classList.add('is-static'); seals.forEach(s => s.classList.add('on')); }
    else {
      const clamp = (x, a = 0, b = 1) => Math.min(b, Math.max(a, x));
      const eio = t => t < .5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      const eob = t => 1 + 2.5 * Math.pow(t - 1, 3) + 1.5 * Math.pow(t - 1, 2);
      const SEG = [3, 2.2, 2.2]; // viewport-heights of scroll per seal (Modern Romance gets the longest run)
      const SUM = SEG.reduce((a, b) => a + b, 0);
      const start = i => SEG.slice(0, i).reduce((a, b) => a + b, 0);
      let W, H, R, C, geo;
      const measure = () => {
        W = stick.clientWidth; H = stick.clientHeight; press.style.height = (SUM + 1) * H + 'px';
        R = Math.min(H * .21, W * .27); C = { x: W / 2, y: H * .46 };
        const iw = Math.max(W, H * 1.5), ih = iw / 1.5;
        const shape = { circle: [1, 1], oval: [.8, 1.06], squircle: [.86, .86] };
        geo = seals.map(s => {
          const fx = +s.dataset.fx, fy = +s.dataset.fy, sw = +s.dataset.sw, sh = s.dataset.shape;
          const S = { x: (W - iw) * fx + fx * iw, y: (H - ih) * .5 + fy * ih };
          const [kx, ky] = shape[sh];
          const s0 = .74 * 2 * R * Math.max(kx, ky) / (sw * iw);
          s.querySelector('img').style.objectPosition = fx * 100 + '% 50%';
                    return { S, s0, kx, ky, sh };
        });
      };
      let active = -1;
      const frame = () => {
        const r = press.getBoundingClientRect();
        const total = press.offsetHeight - H;
        const y = clamp(-r.top, 0, total), vh = y / H;
        let P = 0; for (let i = 0; i < 3; i++) P += clamp((vh - start(i)) / SEG[i]);
        const Rmax = Math.hypot(W, H) / 2 * 1.3;
        seals.forEach((s, i) => {
          const g = geo[i], u = clamp(P - i);
          const layer = s.querySelector('.layer'), halo = s.querySelector('.halo');
          const a = u <= 0 ? 0 : eob(clamp(u / .2));
          const e = eio(clamp((u - .32) / .42));
          const f = a * (1 + (Rmax / R - 1) * e);
          const rx = R * g.kx * f, ry = R * g.ky * f;
          const rr = rx * .38 * (1 - e);
          let clip, rad;
          if (g.sh === 'squircle') {
            clip = `inset(${C.y - ry}px ${W - C.x - rx}px ${H - C.y - ry}px ${C.x - rx}px round ${rr}px)`; rad = rr + 'px';
          } else {
            clip = `ellipse(${rx}px ${ry}px at ${C.x}px ${C.y}px)`; rad = '50%';
          }
          const kk = 1 - eio(clamp((u - .3) / .5));
          const img = layer.firstElementChild;
          layer.style.visibility = u > 0 ? 'visible' : 'hidden';
          layer.style.clipPath = clip;
          img.style.transformOrigin = `${g.S.x}px ${g.S.y}px`;
          img.style.transform = `translate(${(C.x - g.S.x) * kk}px,${(C.y - g.S.y) * kk}px) scale(${1 + (g.s0 - 1) * kk})`;
          const ho = u > 0 ? 1 - clamp((u - .36) / .16) : 0;
          halo.style.visibility = ho > 0 ? 'visible' : 'hidden';
          Object.assign(halo.style, { opacity: ho, left: C.x - rx + 'px', top: C.y - ry + 'px', width: rx * 2 + 'px', height: ry * 2 + 'px', borderRadius: rad });
        });
        cue.style.opacity = 1 - clamp(P / .06);
        const now = Math.min(2, Math.floor(P + .02));
        const pinned = r.top <= 0 && r.bottom >= H;
        if (now !== active) {
          active = now;
          seals.forEach((s, i) => s.classList.toggle('on', i === now));
          pips.forEach((p, i) => p.classList.toggle('on', i === now));
        }
        if (pinned && root.dataset.theme !== seals[now].dataset.tint) root.dataset.theme = seals[now].dataset.tint;
      };
      let tick = false;
      const queue = () => { if (!tick) { tick = true; requestAnimationFrame(() => { tick = false; frame(); }); } };
      addEventListener('scroll', queue, { passive: true });
      addEventListener('resize', () => { measure(); queue(); });
      let glide = 0;
      const glideTo = (to, ms) => {
        cancelAnimationFrame(glide);
        const from = scrollY, t0 = performance.now();
        const stop = () => cancelAnimationFrame(glide);
        addEventListener('wheel', stop, { once: true, passive: true });
        addEventListener('touchstart', stop, { once: true, passive: true });
        const step = now => {
          const t = clamp((now - t0) / ms);
          scrollTo({ top: from + (to - from) * eio(t), behavior: 'instant' });
          if (t < 1) glide = requestAnimationFrame(step);
        };
        glide = requestAnimationFrame(step);
      };
      pips.forEach((p, i) => p.addEventListener('click', () => {
        const top = press.getBoundingClientRect().top + scrollY;
        const to = top + (start(i) + SEG[i] * .9) * H;
        glideTo(to, Math.min(4200, 1400 + Math.abs(to - scrollY) * .45));
      }));
      measure(); frame();
    }
  }

  /* gentle parallax */
  if (!reduce) {
    const items = $$('[data-speed]');
    let ticking = false;
    const run = () => {
      const vh = innerHeight;
      items.forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        const d = (r.top + r.height / 2) - vh / 2;
        let y = d * -parseFloat(el.dataset.speed);
        if (el.classList.contains('parallax')) { const m = el.offsetHeight * .082; y = Math.max(-m, Math.min(m, y)); }
        el.style.transform = `translate3d(0,${y.toFixed(1)}px,0)`;
      });
      ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    addEventListener('resize', run); run();
  }
})();
